<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">{{addType=='add'?'添加':'编辑'}}训练营</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="write-txt">
          <p class="write-title"><span>*</span>标题：</p>
          <div class="write-text">
           <input type="text" placeholder="请填写" v-model="addObj.title">
          </div>
        </div>

        <div class="write-txt" :class="addObj.is_start==1?'noPointer':''">
          <p class="write-title"><span>*</span>开始时间：</p>
          <div class="write-text">
            <el-date-picker
              v-model="addObj.begin_date"
              type="date"
              @change="dateSub('start')"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              placeholder="选择日期">
            </el-date-picker>
            <p class="write-msg">仅能设置明天及以后的时间</p>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>结束时间：</p>
          <div class="write-text">
            <el-date-picker
              v-model="addObj.end_date"
              type="date"
              @change="dateSub('end')"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>

        <div class="write-txt" :class="addObj.is_start==1?'noPointer':''">
          <p class="write-title"><span>*</span>训练周期：</p>
          <div class="write-text">
           <input type="text" v-model="addObj.num" style="display: inline-block;width: 100px;" @change="weekSub">
           <el-radio-group v-model="addObj.unit" @change="studentType" style="margin-left: 20px;vertical-align: top;">
              <el-radio label="d">天</el-radio>
              <el-radio label="w">周</el-radio>
              <el-radio label="m">月</el-radio>
            </el-radio-group>
           <!-- <span style="font-size: 18px;display: inline-block;line-height: 50px;margin-left: 20px;">周</span> -->
           <!-- <button class="btn btn-create" @click="weekCreate">生成</button> -->
          </div>
        </div>

        <div class="" style="display: block;" :class="addObj.is_start==1?'noPointer':''">
          <div class="write-txt" v-for="(item,index) in addObj.week_name" :key="index">
            <p class="write-title"><span>*</span>第{{(index+1)}}周名称：</p>
            <div class="write-text">
            <input type="text" placeholder="请填写" v-model="item.name">
            </div>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>学员：</p>
          <div class="write-text" :class="addObj.student_type==1&&addType=='edit'&&studentStatus?'noPointer':''">
            <el-radio-group v-model="addObj.student_type" @change="studentType">
              <el-radio :label="1">所有学员参加</el-radio>
              <el-radio :label="2">仅部分学员参加</el-radio>
            </el-radio-group>
            <button class="btn btn-choose" @click="chooseStudent" v-if="addObj.student_type==2">{{addObj.student_ids?'查看/编辑已选学员':'选择学生'}}</button>
          </div>
        </div>

        <div class="write-txt write-ai" v-loading="loading" :element-loading-text="loadTxt">
            <p class="write-title"><span>*</span>上传封面：</p>
            <div class="write-text">
              <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
                <img :src="'https://pic.bi-rong.com/'+addObj.image" alt="">
                <div class="hover" v-if="imgType">
                  <i class="el-icon-delete" @click="imgRemove(index)"></i>
                </div>
              </div>
              <el-upload
                :action="'https://upload.qiniup.com'"
                :data="uploadObj"
                list-type="picture-card"
                :before-upload="beforeUploadImg"
                :on-success="handleSuccessImg"
                :on-progress="handleProgressImg"
                :on-remove="handleRemoveImg"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img
                  width="100%"
                  :src="'https://pic.speechcoach.cn/' + addObj.image"
                  alt=""
                />
              </el-dialog>
            </div>
          </div>

        <div class="write-txt" :class="addObj.is_start==1?'noPointer':''">
          <p class="write-title"><span>*</span>类型：</p>
          <div class="write-text">
           <el-radio-group v-model="addObj.type" style="margin-left: 20px;vertical-align: top;">
              <el-radio label="1">现代文阅读</el-radio>
              <el-radio label="2">作文</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>


      <!-- 学生选择列表 -->
      <div class="organiza-txt studentList" v-if="listType">
        <div class="organiza-list" :class="is_up==0?'noPointer':''">
          <div class="list-title">选择学员</div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>学生：</p>
              <input type="text" placeholder="请输入要搜索的学生" v-model="listObj.name">
            </div>
            <div class="search-item">
              <p>手机号：</p>
              <input type="text" placeholder="请输入要搜索的手机号" v-model="listObj.mobile"  @input="numCheck(listObj.mobile,11,'mobile')">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
          <div class="titleList">
            <p v-for="item in studentTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in studentList" v-bind:key="(index+1)" @click="studentChoose(item)" :class="buildStatus&&item.noclick?'noPointer':''">
              <p :title="item.key" class="radio" :class="[item.checked?'select':'']">
                <span></span>
              </p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleStudentChange"
              :current-page.sync="listObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="listTotalPage">
            </el-pagination> 
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="studentSub">确定</button>
          <button class="btn btn-close" @click="studentHide">取消</button>
        </div>
      </div>

      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加训练营</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>标题：</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>状态：</p>
              <el-select v-model="obj.status" filterable placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>创建时间：</p>
              <!-- <input type="text" placeholder="请选择" v-model="obj.create_time"> -->
              <el-select v-model="obj.create_time" filterable placeholder="请选择">
                <el-option
                  v-for="item in sortList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="listSreach">搜索</button>
              <button class="btn btn-reset" @click="listReset">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">活动列表</div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.student_count?item.student_count:'全部'">{{item.student_count?item.student_count:'全部'}}</p>
              <p :title="item.video_num">{{item.video_num}}</p>
              <p :title="item.topic_num">{{item.topic_num}}</p>
              <p :title="item.begin_date">{{item.begin_date}}</p>
              <p :title="item.end_date">{{item.end_date}}</p>
              <p >
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p v-if="item.type == 1">
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="删除" v-if="item.is_up == 1" class="btn btn-remove btn-red" @click="removeShow(item)">删除</button>
                <button title="母题讲解练习" class="btn btn-remove" @click="explainShow(item)">母题讲解练习</button>
                <button title="习题刻意练习" class="btn btn-remove" @click="exercisesShow(item)">习题刻意练习</button>
                <button title="作业" class="btn btn-remove" @click="workShow(item)">作业</button>
              </p>

              <p v-else>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="删除" v-if="item.is_up == 1" class="btn btn-remove btn-red" @click="removeShow(item)">删除</button>
                <button title="习题刻意练习" class="btn btn-remove" @click="exercisesShow(item)">习题</button>
                <button title="作业" class="btn btn-remove" @click="workShow(item)">作业</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      <!-- 母题讲解练习 -->
      <div class="MobelBox explainBox" v-if="explainType">
        <p class="add-title">母题讲解练习</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="write-txt">
          <div class="videoUpload">
            <p class="weekTitle">第一周</p>
            <div class="video-item">
              <p class="write-title"><span>*</span>视频1：</p>
              <div class="write-text">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
                  <img :src="'https://pic.speechcoach.cn/'+addObj.image" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadImg"
                  :on-success="handleSuccessImg"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveImg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://pic.speechcoach.cn/' + addObj.image"
                    alt=""
                  />
                </el-dialog>
              </div>

            </div>
            <div class="video-item">
              <p class="write-title"><span>*</span>视频2：</p>
              <div class="write-text">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
                  <img :src="'https://pic.speechcoach.cn/'+addObj.image" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadImg"
                  :on-success="handleSuccessImg"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveImg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://pic.speechcoach.cn/' + addObj.image"
                    alt=""
                  />
                </el-dialog>
              </div>
              <button class="btn btn-video-add">添加视频</button>
            </div>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <!-- 习题刻意练习 -->
      <div class="MobelBox IntentionallyBox" v-if="IntentionallyType">
        <p class="add-title">习题刻意练习</p>
        <div class="write-txt">
          <p class="write-title"><span>*</span>训练周期：</p>
          <div class="write-text">
           <input type="text">
          </div>
          <button class="btn btn-topic-create">生成</button>
        </div>
        <div class="write-txt">
          <div class="videoUpload">
            <p class="weekTitle">第一周</p>
            <div class="video-item">
              <p class="write-title"><span>*</span>练习题1：</p>
              <div class="write-text">
                <textarea name="" id=""></textarea>
              </div>
              <button class="btn btn-topic-new">重新选择</button>
              <button class="btn btn-topic-build">编辑</button>
              <button class="btn btn-topic-remove">删除</button>
            </div>
            <button class="btn btn-topic-add" @click="addTopic">+添加练习题</button>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <!-- 习题刻意练习 编辑 -->
      <div class="MobelBox" v-if="buildType">
        <p class="add-title">习题刻意练习</p>
        <div class="write-txt">
          <p class="write-title"><span>*</span>文章内容：</p>
          <div class="write-text">
            <textarea placeholder="请输入文章内容" v-model="addObj.content"></textarea>
          </div>
        </div>
        
        <div class="topicList">
          <div class="topic-item" v-for="(item,index) in addObj.topic" :key="index">
            <div class="topic-title">
              题目{{(index+1)}}
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>题干：</p>
              <div class="write-text">
                <textarea placeholder="清输入题干" v-model="item.topic"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title"><span>*</span>答案：</p>
              <div class="write-text">
                <textarea placeholder="请输入答案" v-model="item.answer"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <!-- 作业 -->
      <div class="organiza-txt workBox" v-if="workType">
        <div class="organiza-title clear">
          <div class="searchBox clear">
            <div class="search-item">
              <p>学员姓名：</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>手机号：</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="obj.title">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">作业列表</div>
          <div class="titleList">
            <p v-for="item in workList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.content">{{item.content}}</p>
              <p :title="item.material_label_one">{{item.material_label_one}}</p>
              <p :title="item.material_label_one">{{item.material_label_one}}</p>
              <p :title="item.material_label_three">{{item.material_label_three}}</p>
              <p>
                <button title="修改" class="btn btn-revise" @click="buildShow(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      <!-- 母题讲解练习--作业 -->
      <div class="MobelBox workExamBox" v-if="workExamType">
        <p class="add-title">母题讲解练习</p>
        <div class="week-date">
          <p class="select">第一周</p>
          <p>第二周</p>
          <p>第三周</p>
        </div>
        <div class="write-txt">
          <p class="write-title">选择视频：</p>
          <div class="write-text">
            <div class="week-list">
              <p class="week-txt select">母题1</p>
              <p class="week-txt">母题1</p>
              <p class="week-txt">母题1</p>
              <p class="week-txt">母题1</p>
              <p class="week-txt">母题1</p>
            </div>
          </div>
        </div>
        
        <div class="write-txt">
          <p class="write-title">原视频：</p>
          <div class="write-text">
            
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">学生讲解内容：</p>
          <div class="write-text">
            <button class="btn btn-play">播放语音</button>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">AI点评：</p>
          <div class="write-text">
            <textarea name="" id="" cols="30" rows="10"></textarea>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">老师点评：</p>
          <div class="write-text">
            <textarea name="" id="" cols="30" rows="10"></textarea>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <!-- 母题讲解练习编辑--作业 -->
      <div class="MobelBox workBuildBox" v-if="workBuildType">
        <p class="add-title">母题刻意练习</p>
        <div class="write-txt">
          <p class="write-title">选择视频：</p>
          <div class="write-text">
            <div class="week-list">
              <p class="week-txt select">母题1</p>
              <p class="week-txt">母题1</p>
              <p class="week-txt">母题1</p>
              <p class="week-txt">母题1</p>
              <p class="week-txt">母题1</p>
            </div>
          </div>
        </div>

        <div style="width: 100%;">
          <div class="write-txt">
            <p class="write-title"><span>*</span>题干：</p>
            <div class="write-text">
              <textarea placeholder="清输入题干" v-model="addObj.topic"></textarea>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>学生回答：</p>
            <div class="write-text">
              <textarea placeholder="清输入题干" v-model="addObj.topic"></textarea>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>AI判断结果：</p>
            <div class="write-text">
              <input type="text">
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title"><span>*</span>人工纠错：</p>
            <div class="write-text">
              <input type="text">
            </div>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>AI错因分析：</p>
          <div class="write-text">
            <input type="text">
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>AI练习题讲解：</p>
          <div class="write-text">
            <input type="text">
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title"><span>*</span>老师点评：</p>
          <div class="write-text">
            <input type="text">
          </div>
        </div>

        <div class="WrongQuestion" style="display: block;">
          <div class="wrong-item">
            <p class="wrong-title">第1次错题讲解</p>
            <div class="write-txt">
              <p class="write-title"><span>*</span>学生复盘讲解：</p>
              <div class="write-text">
                <input type="text">
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title"><span>*</span>AI点评：</p>
              <div class="write-text">
                <textarea placeholder="清输入题干" v-model="addObj.topic"></textarea>
              </div>
            </div>
          </div>
        </div>
        
        <!-- <div class="topicList">
          <div class="topic-item" v-for="(item,index) in addObj.topic" :key="index">
            <div class="topic-title">
              题目{{(index+1)}}
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>题干：</p>
              <div class="write-text">
                <textarea placeholder="清输入题干" v-model="item.topic"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title"><span>*</span>答案：</p>
              <div class="write-text">
                <textarea placeholder="请输入答案" v-model="item.answer"></textarea>
              </div>
            </div>
          </div>
        </div> -->

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReadList ,getAiRecognition ,getTypeLabelList ,saveRead ,updateReadStatus ,delRead,getStudentList ,getReadDetail} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import axios from "axios"
export default {
  name: "index",
  data() {
    return {
      navId:'8',
      childrenID:'8-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'标题'},
        {id:3,title:'学员数量'},
        {id:4,title:'母题数量'},
        {id:5,title:'习题数量'},
        {id:6,title:'开始时间'},
        {id:7,title:'结束时间'},
        {id:8,title:'上/下架'},
        {id:9,title:'创建时间'},
        {id:10,title:'操作'},
      ],
      studentTitle:[
        {id:1,title:''},
        {id:2,title:'姓名'},
        {id:3,title:'手机号码'},
      ],
      dataList:[],
      addType:'',
      listObj:{
        page:1,
        rows:10
      },
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        title:'',
        begin_date:'',
        end_date:'',
        num:'',
        student_type:1,
        student_ids:[],
        image:'',
        unit:'d'
      },
      totalPage:0,
      listTotalPage:0,
      removeID:'',
      url:'',
      statusList:[
        {id:9,title:'全部',value:9},
        {id:0,title:'已隐藏',value:0},
        {id:1,title:'已显示',value:1},
      ],
      sortList:[
        {id:1,title:'正序',value:'asc'},
        {id:2,title:'倒序',value:'desc'},
      ],
      loading:false,
      loadTxt:'',
      listType:false,
      explainType:false,
      IntentionallyType:false,
      buildType:false,
      workType:false,
      workExamType:false,
      workList:[
        {id:1,title:'序号'},
        {id:2,title:'姓名'},
        {id:3,title:'手机号'},
        {id:4,title:'母题讲解练习完成率'},
        {id:5,title:'练习题完成率'},
        {id:6,title:'操作'},
      ],
      workBuildType:false,
      is_up:1,
      pickerOptions: {
        disabledDate(time) {
          console.log(time)
          // 获取当前时间的毫秒数
          const now = Date.now();
          // 获取传入日期的毫秒数
          const date = time.getTime();
          // 如果传入日期的毫秒数小于当前时间的毫秒数，则返回true，表示禁用该日期
          return date < now;
        }
      },
      buildStatus:false,
      studentStatus:false,
      imgType:false,
      dialogVisible:false,
      uploadObj: {
        token: "",
        key: "",
      },
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getToken();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    handleStudentChange(val) {
      console.log(`当前页: ${val}`);
      this.chooseStudent();
    },
    getToken(){
      var that = this;
      var url = this.$refs.navBox.url;
      axios({
        url: url+'/api/upload/getUploadToken',
        method:'post', 
      }).then((arr) => {
        if(arr.data.code == 200){
          that.uploadObj.token = arr.data.data.token
        } else {
          that.$message(arr.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    

    dateSub(type){
      if(this.addObj.end_date <  this.addObj.begin_date && this.addObj.end_date){
        this.$message('结束日期禁止小于开始日期');
        this.addObj.end_date='';
        this.addObj.begin_date='';
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getReadList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async switchChange(e){
      var that = this;
      console.log(e)
      var obj = {
        id:e.id,
        status:e.status==false?0:1,
      };
      try {
        const response = await updateReadStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getReadDetail({id:e.id,type:1},this.token);
        if(response.code == 200){
          that.addObj = response.data;
          that.addObj.id = e.id;
          that.addType = 'edit';
          that.buildStatus = true;
          if(that.addObj.student_type == 1){
            that.studentStatus = true;
          }
          that.addObj.type = JSON.stringify(that.addObj.type)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getLabelDetail(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
              that.articleTwoList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_two){
                  that.value2 = item.id;
                }
              })
              that.getLabelDetail(3,'article');
            } else {
              that.topicTwoList = response.data;
              that.topicTwoList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_two){
                  that.topicValue2 = item.id;
                }
              })
              that.getLabelDetail(3,'topic');
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
              that.articleThreeList.forEach(function(item,index){
                if(item.title == that.addObj.material_label_three){
                  that.value3 = item.id;
                }
              })
            } else {
              that.topicThreeList = response.data;
              that.topicThreeList.forEach(function(item,index){
                if(item.title == that.addObj.topic_label_three){
                  that.topicValue3 = item.id;
                }
              })
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delRead({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        that.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请填写标题！');
        return false;
      }
      if(this.addObj.begin_date == ''){
        that.$message('请选择开始时间！');
        return false;
      }
      if(this.addObj.end_date == ''){
        that.$message('请选择结束时间！');
        return false;
      }
      if(this.addObj.num == ''){
        that.$message('请填写周数！');
        return false;
      }
      if(this.addObj.image == ''){
        that.$message('请选择封面！');
        return false;
      }
      if(this.addObj.student_type == 1){
        delete this.addObj.student_ids
      }
      if(this.addObj.student_type == 2 && this.addObj.student_ids.length == 0){
        that.$message('请选择学生！');
        return false;
      }
      try {
        const response = await saveRead(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        title:'',
        begin_date:'',
        end_date:'',
        num:'',
        student_type:1,
        student_ids:[]
      };
      this.listType = false;
      this.studentList = [];
      this.buildStatus = false;
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.getList();
      } else {
        that.$message(response.msg);
      };
      that.loading = false;
    },

    searchSub(){
      this.listObj.page = 1;
      this.studentList = [];
      this.chooseStudent();
    },

    resetSub(){
      this.listObj={
        page:1,
        rows:10,
      };
      this.listTotalPage = 0;
      this.studentList = [];
      this.chooseStudent();
    },

    listSreach(){
      this.obj.page = 1;
      this.getList();
    },

    listReset(){
      this.obj = {
        page:1,
        rows:10
      };
      this.dataList = [];
      this.getList();
    },

    async aiSub(type,i,e){
      var that = this;
      var obj = {};
      if(this.addObj.content == ''){
        that.$message('请填写文章内容！');
        return false;
      }
      if(type=='article'){
        obj = {
          type:1,
          level:i,
          content:this.addObj.content,
        };
        if(i == 2){
          that.addObj.material_label_two = '生成中...'
          obj.material_label_one = that.addObj.material_label_one ? that.addObj.material_label_one : this.value1
        }
        if(i == 3){
          that.addObj.material_label_three = '生成中...'
          obj.material_label_two = that.addObj.material_label_two ? that.addObj.material_label_two : this.value2
        }
        if(i == 1){
          that.addObj.material_label_one = '生成中...'
          that.getTypeList(i,'article')
        }

      } else if(type == 'topic'){
        try {
          that.addObj.topic.forEach(function(item,index){
            if(item.topic == ''){
                that.$message('题目'+(index+1)+'题干还未填写');
                throw new Error("EndIterative");
            } else {
                // console.log(ele,num);
            }
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
        obj = {
          type:2,
          level:i,
          content:this.addObj.content,
          topic:e.topic
        };
        if(i == 2){
          e.topic_label_two = '生成中...'
          obj.topic_label_one = e.topic_label_one ? e.topic_label_one : this.topicValue1;
        }
        if(i == 3){
          e.topic_label_three = '生成中...'
          obj.topic_label_two = e.topic_label_two ? e.topic_label_two : this.topicValue2;
        }
        if(i == 1){
          e.topic_label_one = '生成中...'
          that.getTypeList(i,'topic')
        }
      } else if(type == 'topicType'){
        obj = {
          type:3,
          topic:e.topic,
        }
        e.topic_type = '生成中...'
      };
      this.loading = true;
      this.loadTxt = '请稍后...'
      try {
        const response = await getAiRecognition(obj,this.token);
        if(response.code == 200){
          if(type == 'article'){
            if(i == 1){
              that.addObj.material_label_one = response.data.answer;
              that.value1 = '';
            } else if(i == 2){
              that.addObj.material_label_two = response.data.answer;
              that.value2 = '';
            } else if(i == 3){
              that.addObj.material_label_three = response.data.answer;
              that.value3 = '';
            } 
          } else if(type == 'topic'){
            if(i == 1){
              e.topic_label_one = response.data.answer;
              that.topicValue1 = '';
            } else if(i == 2){
              e.topic_label_two = response.data.answer;
              that.topicValue2 = '';
            } else if(i == 3){
              e.topic_label_three = response.data.answer;
              that.topicValue3 = '';
            } 
          } else if(type == 'topicType'){
            e.topic_type = response.data.answer;
          };
          that.$forceUpdate();
          that.loading = false;
        } else {
          that.$message(response.msg);
          that.loading = false;
        }
      } catch (error) {
        that.$message(error);
        that.loading = false;
      }
    },

    async getTypeList(i,type){
      var that = this;
      var obj = {};
      if(i == 1){
        obj = {
          type:i,
          table_type:1
        }
        if(type == 'topic'){
          obj.table_type = 2
        }
      }
      if(i == 2){
        obj = {
          type : 2,
          one_id:that.value1,
          table_type:1
        };
        if(type == 'topic'){
          obj.one_id = this.topicValue1;
          obj.table_type = 2
        };
      }
      if(i == 3){
        obj = {
          type : 3,
          two_id:this.value2,
          table_type:1
        }
        if(type == 'topic'){
          obj.two_id = that.topicValue2;
          obj.table_type = 2
        }
      }
      try {
        const response = await getTypeLabelList(obj,this.token);
        if(response.code == 200){
          if(i == 1){
            if(type == 'article'){
              that.articleOneList = response.data;
            } else {
              that.topicOneList = response.data;
            }
          }
          if(i == 2){
            if(type == 'article'){
              that.articleTwoList = response.data;
            } else {
              that.topicTwoList = response.data;
            }
          }
          if(i == 3){
            if(type == 'article'){
              that.articleThreeList = response.data;
            } else {
              that.topicThreeList = response.data;
            }
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    articleLabel(type,e,topic,num){
      var that = this;
      if(type == 1){
        if(topic == 'topic'){
          that.getTypeList(2,'topic');
          that.topicOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_one = item.title
            }
          });
          that.addObj.topic[num].topic_label_two = '';
          that.topicValue2 = '';
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTypeList(2,'article');
          that.addObj.material_label_two = '';
          that.value2 = '';
          that.addObj.material_label_three = '';
          that.value3 = '';
          that.articleOneList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_one = item.title
            }
          });
          
        }
      } else if(type == 2){
        if(topic == 'topic'){
          that.getTypeList(3,'topic')
          that.topicTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_two = item.title
            }
          });
          that.addObj.topic[num].topic_label_three = '';
          that.topicValue3 = '';
        } else {
          that.getTypeList(3,'article')
          that.articleTwoList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_two = item.title
            }
          });
          that.addObj.material_label_three = '';
          that.value3 = '';
        }
      } else if(type == 3){
        if(topic == 'topic'){
          that.topicThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.topic[num].topic_label_three = item.title
            }
          });
        } else {
          that.articleThreeList.forEach(function(item,index){
            if(e == item.id){
              that.addObj.material_label_three = item.title
            }
          });
        }
      }
    },

    addTopic(){
      var list = {
        topic:'',
        topic_type:'',
        answer:'',
        topic_label_one:'',
        topic_label_two:'',
        topic_label_three:'',
      }
      this.addObj.topic.push(list);
    },

    removeTopic(e,i){
      this.addObj.topic.splice(i,1)
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,index,type,num) {
      var that = this;
      that.addObj.image = response.key;
      that.loading = false;
      that.uploadObj.key = "";
      this.$forceUpdate();
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
    },

    async chooseStudent(){
      var that = this;      
      try {
        const response = await getStudentList(this.listObj,this.token);
        if(response.code == 200){
          that.listType = true;
          that.addType = '';
          that.studentList = response.data.list;
          that.listTotalPage = response.data.total_page;
          if(that.addObj.student_ids){
            that.addObj.student_ids.forEach(function(item,index){
              that.studentList.forEach(function(ele,num){
                if(ele.id == item){
                  ele.checked = true;
                  if(that.buildStatus){
                    ele.noclick = true;
                  }
                }
              })
            });
          } else {
            response.data.list.forEach(function(item,index){
              item.checked = false;
            })
            that.studentList = response.data.list;
            that.addObj.student_ids = [];
          };
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    studentChoose(e){
      if(this.buildStatus&&e.noclick){
        return false;
      }
      e.checked = !e.checked;
      this.$forceUpdate();
    },

    studentSub(){
      var that = this;
      that.addObj.student_ids = [];
      this.studentList.forEach(function(item,index){
        if(item.checked){
          that.addObj.student_ids.push(item.id)
        }
      });
      if(this.buildStatus){
        this.addType = 'edit';
      } else {
        this.addType = 'add';
      }
      this.listType = false;
      this.buildStatus = false;
    },

    studentHide(){
      this.listType = false;
      if(this.buildStatus){
        this.addType = 'edit';
      } else {
        this.addType = 'add';
      }
      this.studentList = [];
      this.buildStatus = false;
    },

    explainShow(e){
      this.$router.push('/explain?id='+e.id+'&is_up='+e.is_up);
    },

    exercisesShow(e){
      this.$router.push('/exercises?id='+e.id+'&is_up='+e.is_up+'&type='+e.type);
    },

    workShow(e){
      this.$router.push('/work?id='+e.id);
      // this.$message('暂无，前端做好才能测')
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.listObj.mobile = e;
          }
      }
    },

    weekSub(){
      var that = this;
      if(that.addObj.week_name){
        var num1 = this.addObj.num;
        var num2 = this.addObj.week_name.length;
        if(num1 < num2){
            that.addObj.week_name = that.addObj.week_name.slice(0,parseInt(num1));
        } else if(num1 > num2){
          for(var i = 0;i < parseInt(num1-num2);i++){
            that.addObj.week_name.push({name:''})
          }
        }
      } else {
        that.addObj.week_name = [];
        for(var i = 0;i < that.addObj.num;i++){
          that.addObj.week_name.push({name:''})
        }
      };
      this.$forceUpdate();
    },

    weekCreate(){

    },

    studentType(){
      console.log(this.addObj.student_ids)
    }
  }

 

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 10 );
  }

  .dataList .listItem p:nth-of-type(8), 
  .organiza-list p:nth-of-type(8){
    width: 8%;
  }

  .dataList .listItem p:last-child, 
  .organiza-list p:last-child{
    width: 12%;
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-topic-create{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  margin-left: 20px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}

.MobelBox>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.MobelBox>>> .el-radio{
  line-height: 50px;
}

.MobelBox>>> .el-radio__label{
  font-size: 18px;
}

.MobelBox>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.btn-topic-add{
  font-size: 16px;
  color: #6098F2;
  margin-top: 30px;
  display: block;  
  border: solid 1px #6098F2;
  border-radius: 6px;
  padding: 5px 15px;
  box-sizing: border-box;
}

.studentList .searchBox {
  padding: 0;
  margin-top: 25px;
  float: none;
}

.studentList .searchBox .search-item p{
  width: 80px;
  padding: 0;
}

.studentList .titleList{
  background-color: #F0F4FB;
  margin-top: 20px;
}

.studentList .dataList .listItem p,
.studentList .organiza-list p{
  width: calc( 100% / 3 );
}

.studentList .dataList .listItem p.radio span{
  width: 20px;
  height: 20px;
  background-color: #D9D9D9;
  border-radius: 4px;
  display: block;
}

.studentList .dataList .listItem p.select span{
  background-color: #6098F2;
}

.studentList .dataList .listItem p.select span::before{
  content: '✔';
  width: 20px;
  height: 20px;
  display: block;
  color: #ffff;
  margin: 0 5px;
}

.videoUpload{
  font-size: 0;
}

.videoUpload .weekTitle{
  font-size: 20px;
  position: relative;
  margin: 0 0 20px 45px;
}


.videoUpload .weekTitle::before{
  content: '';
  width: 5px;
  height: 18px;
  background-color: #6098F2;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0,-50%);
  transform: translate(0,-50%);
  left: -15px;
}

.videoUpload .video-item{
  padding: 0 70px;
  box-sizing: border-box;
  margin-top: 20px;
}

.IntentionallyBox .videoUpload .video-item .btn{
  font-size: 18px;
  color: #333333;
  border: solid 1px #333333;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 9px 20px;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
}

.IntentionallyBox .videoUpload .video-item .btn.btn-topic-remove{
  background-color: #6098F2;
  color: #fff;
  border: solid 1px transparent;
}

.IntentionallyBox .videoUpload .video-item textarea{
  width: 430px;
  height: 112px;
  border: solid 1px #ECECEC;
  margin-left: 20px;
}

.IntentionallyBox .write-text{
  width: auto;
}

.videoUpload .btn-video-add{
  font-size: 18px;
  color: #fff;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: #6098F2;
  margin-left: 20px;
}

.MobelBox.explainBox .write-text{
  width: auto;
}

/* .workBox */
.workBox .dataList .listItem p, 
.workBox .organiza-list p{
  width: calc( 100% / 6 );
}

.week-list{
  font-size: 0;
}

.week-date{
  font-size: 0;
  margin-bottom: 30px;
}

.week-date p{
  color: #777777;
  font-size: 22px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
}

.week-date p.select{
  font-size: 26px;
  color: #333333;
  border-bottom: solid 4px #6098F2;
  padding-bottom: 6px;
}

.week-list .week-txt{
  font-size: 18px;
  color: #999999;
  box-sizing: border-box;
  padding: 9px 35px;
  border-radius: 6px;
  background-color: #F5F5F5;
  margin-right: 20px;
  display: inline-block;
  vertical-align: top;
}

.week-list .week-txt.select{
  background-color: #6098F2;
  color: #fff;
}

.workExamBox .btn-play{
  width: 144px;
  height: 40px;
  color: #fff;
  background-color: #6098F2;
  border-radius: 6px;
  font-size: 18px;
}

.wrong-title{
  font-size: 24px;
  color: #333333;
  margin-bottom: 20px;
}

.btn-choose{
  font-size: 18px;
  color: #fff;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: #6098F2;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}

.searchBox{
  margin-top: 30px;
}

@media screen and (max-width: 1600px){
  .dataList .listItem p, 
  .organiza-list p{
    padding: 10px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/marketing/index.vue